import { SET_DEALER_SETTINGS, SET_AMENITIES } from './actionTypes';
import xws from 'api/xws/';

// Selectors
import { getWebkey, getVariant } from 'store/reducers/queryParams/selectors';
import { dealerLocaleSelector } from 'store/reducers/dealerLocale/selectors';
import { getTokenId } from 'store/reducers/tokenId/selectors';
import { getLocalizationStrings } from 'store/reducers/localizationString/selectors';
import { amenities as getAmenities } from 'store/reducers/dealerSettings/selectors';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

// Constants
import { getService } from 'constants/ajax';

export function setDealerSettings(dealerSettings) {
  return {
    type: SET_DEALER_SETTINGS,
    payload: dealerSettings
  };
}

function setAmenitiesKeys(amenitiesKeys) {
  return {
    type: SET_AMENITIES,
    payload: amenitiesKeys
  };
}

export const getDealerSettings = params => async (dispatch, getState) => {
  const settingsService = getService('settings');
  const webkey = getWebkey(getState());
  settingsService.setPathVars({ webkey });
  settingsService.setCallBacks(dispatch(ajaxCallbacks()));
  const {
    data: { dealerSettings }
  } = await xws(settingsService).get(settingsService.getPath(), {
    params: {
      tokenId: getTokenId(getState()),
      variant: getVariant(getState()),
      ...dealerLocaleSelector(getState())
    }
  });

  await dispatch(setDealerSettings(dealerSettings));
  dispatch(setAmenities());
};

const setAmenities = () => async (dispatch, getState) => {
  const localizationStrings = getLocalizationStrings(getState());
  const amenitiesKeys = [];
  const amenities = getAmenities(getState());

  for (const key in localizationStrings) {
    if (
      localizationStrings.hasOwnProperty(key) &&
      key.indexOf('c8.drop.off.amenities.') > -1 &&
      amenities.indexOf(localizationStrings[key]) > -1
    ) {
      amenitiesKeys.push(key);
    }
  }

  dispatch(setAmenitiesKeys(amenitiesKeys.sort()));
};



// WEBPACK FOOTER //
// ./src/store/reducers/dealerSettings/actions.js